import scrollElementToBottom from './scrollElementToBottom';
import scrollWindowToBottom from './scrollWindowToBottom';

export default () => {
    const element: HTMLElement = document.querySelector('.show .modal-body');
    if (element) {
        scrollElementToBottom(element);
    } else {
        scrollWindowToBottom();
    }
};
